import * as LabelPrimitive from '@radix-ui/react-label'
import * as React from 'react'
import { tv, VariantProps } from 'tailwind-variants'

import { cn } from '~in-app/lib/utils'

const labelVariants = tv({
  base: 'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
  variants: {
    required: {
      true: "after:ml-0.5 after:text-error after:content-['*']",
      false: '',
    },
  },
})

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>, React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, children, required, ...props }, ref) => {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(labelVariants({ className, required }))}
      {...props}
    >
      {children}
    </LabelPrimitive.Root>
  )
})
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
